function cssAnimationControll() {
	$( document ).ready(function() {
		$('body').addClass('run-animations');
	});
}